/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasty_Swift_Dachshund_RadiateInputs */

const fr_tasty_swift_dachshund_radiate = /** @type {(inputs: Tasty_Swift_Dachshund_RadiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`06 37 15 75 85`)
};

/**

* @param {Tasty_Swift_Dachshund_RadiateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tasty_swift_dachshund_radiate = /** @type {((inputs?: Tasty_Swift_Dachshund_RadiateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasty_Swift_Dachshund_RadiateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tasty_swift_dachshund_radiate(inputs)
});